import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // First, check if a scrollable container exists
    const container = document.querySelector("#main-content");

    if (container) {
      // console.log(
      //   "Scrolling scrollable container to top for route:",
      //   location.pathname
      // );
      container.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // console.log("Scrolling window to top for route:", location.pathname);
      // Default to scrolling the window
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);
};

export default useScrollToTop;
